import type { ReactNode } from "react";

interface Props {
  variant: "error" | "success" | "info";
  children: ReactNode;
}

export default function Alert({ variant, children }: Props): JSX.Element {
  const color =
    variant === "error"
      ? "var(--error)"
      : variant === "success"
        ? "var(--ok)"
        : "var(--accent)";
  return (
    <div
      role={variant === "error" ? "alert" : "status"}
      style={{
        padding: "0.6rem 0.75rem",
        background: `${color}22`,
        border: `1px solid ${color}`,
        color: "var(--fg)",
        borderRadius: 6,
        fontSize: 14,
        marginBottom: "1rem",
      }}
    >
      {children}
    </div>
  );
}
